export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "container_planning": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Planeación de contenedor"])},
            "container_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedor"])},
            "num_package_groups": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad de pallets"])},
            "packages_per_pg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad de empaques por pallet"])},
            "package_detail_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Detallado de empaques"])},
            "num_total_packages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total de empaques"])},
            "observations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Observaciones"])}
          }
        }
      },
      "en": {
        "model": {
          "container_planning": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container Planning"])},
            "container_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container"])},
            "num_package_groups": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Number of pallet"])},
            "packages_per_pg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Number of packages per pallet"])},
            "package_detail_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Package detail"])},
            "num_total_packages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total of packages"])},
            "observations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Observations"])}
          }
        }
      }
    }
  })
}